
// Import React to fix namespace error for React.ReactNode
import React from 'react';

export enum Sector {
  Industrial = 'Industrial',
  Residential = 'Residential',
  Gov = 'Gov'
}

export interface CaseStudy {
  id: string;
  clientName: string;
  logo: string;
  sector: Sector;
  quote: string;
  author: {
    name: string;
    role: string;
  };
  metrics: {
    energySaved: number;
    co2Reduced: number;
  };
  heroImage: string;
}

export interface Service {
  id: string;
  title: string;
  description: string;
  link: string;
}

export interface Feature {
  id: string;
  title: string;
  description: string;
  icon: React.ReactNode;
}
